export enum EmployeeErrorOrigin {
    GET_RECORDS = 'GET_RECORDS',
}

export interface EmployeeError {
    type: EmployeeErrorOrigin,
    detail: any
}